import type { PickupPointLocation } from 'services';

/** Display text of a pickup point; also the value the combobox stores as the selected station. */
export function getPickupPointText(location: PickupPointLocation): string {
  return `${location.name}, ${location.address}`;
}
